// extracted by mini-css-extract-plugin
export default {"imagesList":"CuratedPhotos_imagesList__OwKcR","double":"CuratedPhotos_double__i9KCN","imageThumbnail":"CuratedPhotos_imageThumbnail__KDfNy"};